// https://developers.facebook.com/docs/graph-api/reference/page/

// curl -i -X GET "https://graph.facebook.com/PAGE-ID?access_token=ACCESS-TOKEN"
// curl -i -X GET "https://graph.facebook.com/facebook/picture?redirect=false"

// https://www.facebook.com/profile.php?id=100051159686654
// https://www.facebook.com/photo?fbid=812392660476049&set=pcb.812395823809066
// https://scontent.fyto1-1.fna.fbcdn.net/v/t39.30808-6/476250742_1124010279314284_8335526431296491042_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=833d8c&_nc_ohc=-XH4Gw6lsHUQ7kNvwH1pBRq&_nc_oc=Adl-bH4Gz1L-cOCk7mFyUlvNRvzzethw4sfWo8S53xO_mbtHWDhMCxJA1vq1ThAcSbg&_nc_zt=23&_nc_ht=scontent.fyto1-1.fna&_nc_gid=MMCaeHx1zchxiwnewhAm2A&oh=00_AfcNMXGhOySynSL6VbMOYVMO1iDrg_KVKhVYWBUwIYOvvw&oe=68F078B6

// ClientToken
// Clipdeo:     41f9526dc6db41c9d966de7dde320ee1
// ClipdeoData: 650f918d54e6bf9f189d5e5fb4b61390

// curl -i -X GET "https://graph.facebook.com/100051159686654?access_token=41f9526dc6db41c9d966de7dde320ee1"
// curl -i -X GET "https://graph.facebook.com/100051159686654?access_token=650f918d54e6bf9f189d5e5fb4b61390"

// curl -i -X GET "https://graph.facebook.com/100051159686654?access_token=EAAJhu3Ng724BPvRPpcrBny6GiEl2typFuPXHi9CrLX5bycIINEKQx6Msnj2RheZAKBYQ78ZCND5xO1DELWwbuIZCnOQbxRCHZCGUoHKsq4HJ9HC5RpV9YaFHgb4BlQCXbmDpf4Lf4xbL9LOkant7ej5mDhq3dZBZAs9sVZCchZBZBPpRt5zGgAC0nCEZC6FYF3ZB6OX9M19OiP7gXxIjJ1AZADOnnI7uKIB7HUKO4IMi"


import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import config from '../config';
import Layout from '../layout/Layout';
import AlbumList from '../components/AlbumList';
import AlbumGallery from '../components/AlbumGallery';
import AlbumCollage from '../components/AlbumCollage';

export default function Facebook() {
    const [albums, setAlbums] = useState([]);
    const [selectedAlbum, setSelectedAlbum] = useState(0);
    const [albumItems, setAlbumItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(0);

    const homePath = 'jshome';

    useEffect(() => {
        getAlbums();
    }, []);

    const getAlbums = async () => {
        try {
            const response = await axios.get(`${config.apiBaseUrl}/album/albums`);
            // console.log(response);
            // console.log(response?.data);
            // console.log(response?.data[5]?.items);

            // console.log(new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(Date.now()));
            // console.log(created_at.slice(0, 10));

            setAlbums(response?.data);      
            if (response?.data.length > 0) {
                setAlbumItems(response?.data[selectedAlbum]?.items);
            }

        } catch (error) {
            toast.error("Failed to get albums");
        }
    };

    const handleClick = (param, e) => {
        setSelectedAlbum(param);
        setAlbumItems(albums[param].items);
        setSelectedItem(0);
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    };

    if (albums.length <= 0) {
        return (
            <Layout>
                <div className="text-lg font-bold italic mt-4 text-center text-orange-200">
                    Loading ...
                </div>
            </Layout>
        );
    }

    return (
        <Layout>
            <div className='flex'>
                <div className='hidden custom-flex'>
                    <div>
                        <AlbumList
                            homePath={homePath}
                            albums={albums}
                            selectedAlbum={selectedAlbum}
                            handleClick={handleClick}
                        />
                    </div>
                    <div>
                        <AlbumGallery
                            homePath={homePath}
                            albumCode={albums[selectedAlbum]?.album_code}
                            albumItems={albumItems}
                            setSelectedItem={setSelectedItem}
                        />                  
                    </div>
                </div>
                <div>
                    <AlbumCollage
                        albumTitle={albums[selectedAlbum]?.title}
                        albumNotes={albums[selectedAlbum]?.notes ? albums[selectedAlbum]?.notes : albums[selectedAlbum]?.created_at.slice(0, 10)}
                        albumType={albums[selectedAlbum]?.album_type}
                        homePath={homePath}
                        albumCode={albums[selectedAlbum]?.album_code}
                        albumItems={albumItems}
                        selectedItem={selectedItem}
                    />

                    <div className='flex custom-hidden justify-center'>
                        <AlbumList
                            homePath={homePath}
                            albums={albums}
                            selectedAlbum={selectedAlbum}
                            handleClick={handleClick}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

